import * as wooutils from "./utils.js";
import * as masonry from "../plugins/masonry.js";

export function init() {
  jQuery(".reviews_tab").on("click", function () {
    setTimeout(function () {
      masonry.init();
    }, 2000);
  }); // issue window resize so masonry reviews can recalculate layout

  if (jQuery(".gform_body .stars .gfield_radio .gchoice").length > 0) {
    jQuery(".gform_body .stars .gfield_radio .gchoice").on(
      "click",
      function () {
        jQuery(".gform_body .stars .gfield_radio .gchoice").addClass("on");
        jQuery(this).children("input").attr("checked", "checked");
        var thisval = jQuery(this).children("input").val();
        jQuery(".gform_body .stars .gfield_radio .gchoice").each(function () {
          var lessval = jQuery(this).children("input").val();
          if (lessval > thisval) {
            jQuery(this).removeClass("on");
          }
        });
      }
    );
  }

  if (jQuery("body").hasClass("single-product")) {
    var sel_variation = wooutils.get_selected_variation();

    if (sel_variation) {
      wooutils.showbuyform(sel_variation);
    }

    jQuery(".single_variation_wrap").on(
      "show_variation",
      function (event, variation) {
        var vardetails = wooutils.get_selected_variation(
          variation.variation_id
        );

        var outofstock_title = vardetails.outofstock_title;
        var outofstock_button_text = vardetails.outofstock_button_text;

        if (outofstock_title) {
          jQuery(".stockcomingsoon .preordertitle").html(outofstock_title);
        }
        if (outofstock_button_text) {
          jQuery(".stockcomingsoon .productenquire").html(
            outofstock_button_text
          );
        }
        var price = vardetails.display_price;
        var variation_description = vardetails.variation_description;
        var productid = vardetails.variation_id;
        var sku = vardetails.sku;

        jQuery(".product_title").attr("data-product_sku", sku);
        jQuery(".product_title").attr("data-product_variationid", productid);
        jQuery(".product_title").attr("data-product_price", price);
        jQuery(".product_title").attr(
          "data-product_variation",
          variation_description
        );

        var imageid = vardetails.image_id;

        var thumbnail = jQuery(
          `.product_thumbnails img[data-imageid='${imageid}']`
        );
        var image = variation.image.src;
        jQuery(".productenquiryform").attr("data-image", image);

        var slideno = thumbnail.closest(".slide-item").attr("data-itemno");

        jQuery(".product_thumbnails").slick("slickGoTo", slideno - 1);
        wooutils.showbuyform(variation);
      }
    );

    jQuery(".starreviews").on("click", function () {
      gotoreviews();
    });
  }
}

export function show_closest_stockist(lat, lng, elid) {
  var thisel = jQuery("#" + elid).parent();

  console.log("postcode changed");

  thisel.html(
    "<p align='center'><img src='/wp-content/themes/cargocycles/assets/images/ajax-loading.gif' /></p>"
  );

  jQuery.post(
    base.ajaxurl,
    {
      action: "closest_stockist",
      lat: lat,
      lng,
      lng,
    },
    function (r) {
      var r = JSON.parse(r);
      var stockistid = r.stockist.id;
      var stockistname = r.stockist.name;
      var stockistaddress = r.stockist.address;
      var distance = r.distance;

      var productid =
        jQuery("input[name='product_id']").length > 0
          ? jQuery("input[name='product_id']").val()
          : jQuery("button[name='add-to-cart']").length > 0
          ? jQuery("button[name='add-to-cart']").val()
          : jQuery(".productwheretobuy").attr("data-productid");
      var variationid =
        jQuery("input[name='variation_id']").length > 0
          ? jQuery("input[name='variation_id']").val()
          : 0;

      productid = variationid > 0 ? variationid : productid;
      var rHTML = "";

      if (stockistid == -1) {
        rHTML =
          "Sorry, there are currently no stockists in your area. Please contact Cargocycles for a direct shipping quote.";
        addtocart =
          "<span class='btn'>Click here to contact Cargocycles</span>";
      } else if (stockistid == 13918) {
        rHTML =
          "Your nearest store is us! Cargocycles -  " + distance + "km away.";

        //
        //  rHTML = `<a data-quantity="1" class="button product_type_simple add_to_cart_button ajax_add_to_cart" data-product_id="${addtocartid}" aria-label="Add ${productname} to your cart" rel="nofollow">Purchase from Cargocycles</a>`;
      } else {
        rHTML = `Your nearest stockist is <b>${stockistname}</b> ${distance}km away.<br /><br />
            <a data-productid='${productid}' class='mts productenquire btn btn-primary'>Click here to send them an enquiry today</a>`;
      }

      thisel.html(rHTML);

      // jQuery(".stockistchecker .stockist").html(neareststockist + "<br /><br />" +  addtocart);
      // jQuery(".stockistchecker").on("click",".stockist span.btn",function(e){
      //     e.stopPropagation();
      //     jQuery(".productenquire").trigger("click");
      // });

      // jQuery(".stockistchecker .stockist").on("click",".addtocarttrigger",function(e){
      //     e.stopPropagation();

      //     jQuery(".single_add_to_cart_button").trigger("click");

      // });
    }
  );
}

jQuery(window).on("load", function () {
  init();
});
